// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessPage-module--container--hPgXG","businessForm":"BusinessPage-module--business-form--2_azO"};